import { c as _c } from "react/compiler-runtime";
import CommonDropdownItemsMobileWrapper from "@/components/utils/select/dropdown/CommonDropdownItemsMobileWrapper";
import WaveDropActionsOpen from "@/components/waves/drops/WaveDropActionsOpen";
import WaveDropMobileMenuOpen from "@/components/waves/drops/WaveDropMobileMenuOpen";
import { ApiWaveDecisionWinner } from "@/generated/models/ApiWaveDecisionWinner";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { ExtendedDrop, convertApiDropToExtendedDrop } from "@/helpers/waves/drop.helpers";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import useLongPressInteraction from "@/hooks/useLongPressInteraction";
import React from "react";
import { createPortal } from "react-dom";
import { WaveWinnersDropHeader } from "./header/WaveWinnersDropHeader";
import WaveWinnersDropHeaderAuthorPfp from "./header/WaveWinnersDropHeaderAuthorPfp";
import WaveWinnersDropHeaderTotalVotes from "./header/WaveWinnersDropHeaderTotalVotes";
import WaveWinnersDropHeaderVoters from "./header/WaveWinnersDropHeaderVoters";
import WaveWinnersDropOutcome from "./header/WaveWinnersDropOutcome";
import { WaveWinnersDropContent } from "./WaveWinnersDropContent";
interface DefaultWaveWinnersDropProps {
  readonly winner: ApiWaveDecisionWinner;
  readonly onDropClick: (drop: ExtendedDrop) => void;
}
const getRankShadowClass = (place: number | null): string => {
  if (!place) return "tw-shadow-[inset_1px_0_0_rgba(96,96,108,0.5),inset_0_1px_0_rgba(96,96,108,0.2),inset_-1px_0_0_rgba(96,96,108,0.2),inset_0_-1px_0_rgba(96,96,108,0.2)]";
  switch (place) {
    case 1:
      return "tw-shadow-[inset_1px_0_0_rgba(251,191,36,0.5),inset_0_1px_0_rgba(251,191,36,0.2),inset_-1px_0_0_rgba(251,191,36,0.2),inset_0_-1px_0_rgba(251,191,36,0.2)]";
    case 2:
      return "tw-shadow-[inset_1px_0_0_rgba(148,163,184,0.5),inset_0_1px_0_rgba(148,163,184,0.2),inset_-1px_0_0_rgba(148,163,184,0.2),inset_0_-1px_0_rgba(148,163,184,0.2)]";
    case 3:
      return "tw-shadow-[inset_1px_0_0_rgba(205,127,50,0.5),inset_0_1px_0_rgba(205,127,50,0.2),inset_-1px_0_0_rgba(205,127,50,0.2),inset_0_-1px_0_rgba(205,127,50,0.2)]";
    default:
      return "tw-shadow-[inset_1px_0_0_rgba(96,96,108,0.5),inset_0_1px_0_rgba(96,96,108,0.2),inset_-1px_0_0_rgba(96,96,108,0.2),inset_0_-1px_0_rgba(96,96,108,0.2)]";
  }
};
export const DefaultWaveWinnersDrop: React.FC<DefaultWaveWinnersDropProps> = t0 => {
  const $ = _c(46);
  const {
    winner,
    onDropClick
  } = t0;
  const {
    hasTouchScreen
  } = useDeviceInfo();
  let t1;
  if ($[0] !== hasTouchScreen) {
    t1 = {
      hasTouchScreen
    };
    $[0] = hasTouchScreen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    isActive,
    setIsActive,
    touchHandlers
  } = useLongPressInteraction(t1);
  let t2;
  if ($[2] !== winner.place) {
    t2 = getRankShadowClass(winner.place);
    $[2] = winner.place;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const shadowClass = t2;
  let t3;
  if ($[4] !== winner.drop) {
    t3 = convertApiDropToExtendedDrop(winner.drop);
    $[4] = winner.drop;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const extendedDrop = t3;
  const hasUserVoted = winner.drop.context_profile_context?.rating !== undefined && winner.drop.context_profile_context?.rating !== 0;
  const userVote = winner.drop.context_profile_context?.rating ?? 0;
  const isUserVoteNegative = userVote < 0;
  const creditType = winner.drop.wave.voting_credit_type || "votes";
  let t4;
  if ($[6] !== extendedDrop || $[7] !== onDropClick) {
    t4 = () => onDropClick(extendedDrop);
    $[6] = extendedDrop;
    $[7] = onDropClick;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = `tw-group tw-cursor-pointer tw-rounded-xl tw-bg-iron-950 tw-border tw-border-solid tw-border-transparent tw-border-l ${shadowClass}`;
  let t6;
  if ($[9] !== winner) {
    t6 = <WaveWinnersDropHeaderAuthorPfp winner={winner} />;
    $[9] = winner;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== winner) {
    t7 = <div className="tw-flex tw-flex-col tw-w-full tw-gap-y-2"><WaveWinnersDropHeader winner={winner} showVotingInfo={false} /><WaveWinnersDropContent winner={winner} isCompetitionDrop={true} /></div>;
    $[11] = winner;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6 || $[14] !== t7) {
    t8 = <div className="tw-flex tw-gap-x-3 tw-flex-1">{t6}{t7}</div>;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== extendedDrop || $[17] !== hasTouchScreen) {
    t9 = !hasTouchScreen && <div className="tw-flex tw-items-start tw-flex-shrink-0"><div className="tw-h-8"><WaveDropActionsOpen drop={extendedDrop} /></div></div>;
    $[16] = extendedDrop;
    $[17] = hasTouchScreen;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t8 || $[20] !== t9) {
    t10 = <div className="tw-flex tw-justify-between tw-gap-x-3 tw-relative tw-z-10 tw-w-full tw-text-left tw-bg-transparent tw-border-0">{t8}{t9}</div>;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== winner) {
    t11 = <div className="tw-flex tw-items-center tw-flex-wrap tw-gap-x-4 tw-gap-y-2"><div className="tw-flex tw-flex-whitespace-nowrap tw-gap-x-4 tw-items-center"><WaveWinnersDropHeaderTotalVotes winner={winner} /><WaveWinnersDropHeaderVoters winner={winner} /></div><div><WaveWinnersDropOutcome winner={winner} /></div></div>;
    $[22] = winner;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== creditType || $[25] !== hasUserVoted || $[26] !== isUserVoteNegative || $[27] !== userVote) {
    t12 = hasUserVoted && <div className="tw-flex tw-items-center tw-gap-x-1.5"><div className="tw-flex tw-items-baseline tw-gap-x-1"><span className="tw-text-sm tw-font-normal tw-text-iron-400">Your vote:</span><span className={`tw-text-sm tw-font-semibold ${isUserVoteNegative ? "tw-text-rose-500" : "tw-text-emerald-500"}`}>{isUserVoteNegative && "-"}{formatNumberWithCommas(Math.abs(userVote))}{" "}<span className="tw-text-iron-400 tw-font-normal">{creditType}</span></span></div></div>;
    $[24] = creditType;
    $[25] = hasUserVoted;
    $[26] = isUserVoteNegative;
    $[27] = userVote;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t11 || $[30] !== t12) {
    t13 = <div className="tw-mt-3 tw-ml-[3.5rem]"><div className="tw-flex tw-flex-col tw-gap-y-2">{t11}{t12}</div></div>;
    $[29] = t11;
    $[30] = t12;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== t10 || $[33] !== t13 || $[34] !== touchHandlers) {
    t14 = <div className="tw-rounded-xl tw-p-4" {...touchHandlers}>{t10}{t13}</div>;
    $[32] = t10;
    $[33] = t13;
    $[34] = touchHandlers;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== extendedDrop || $[37] !== hasTouchScreen || $[38] !== isActive || $[39] !== setIsActive) {
    t15 = hasTouchScreen && createPortal(<CommonDropdownItemsMobileWrapper isOpen={isActive} setOpen={setIsActive}><div className="tw-grid tw-grid-cols-1 tw-gap-y-2"><WaveDropMobileMenuOpen drop={extendedDrop} onOpenChange={() => setIsActive(false)} /></div></CommonDropdownItemsMobileWrapper>, document.body);
    $[36] = extendedDrop;
    $[37] = hasTouchScreen;
    $[38] = isActive;
    $[39] = setIsActive;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  let t16;
  if ($[41] !== t14 || $[42] !== t15 || $[43] !== t4 || $[44] !== t5) {
    t16 = <div onClick={t4} className={t5}>{t14}{t15}</div>;
    $[41] = t14;
    $[42] = t15;
    $[43] = t4;
    $[44] = t5;
    $[45] = t16;
  } else {
    t16 = $[45];
  }
  return t16;
};